export default __webpack_public_path__ + "static/media/trends.eb86d533.jpg";